const heroData = {
  stackText: '+5000 EMPRESAS CONFÍAN EN NOSOTROS',
  titleText: 'Haz que tu negocio siga avanzando',
  subtitleText: 'Recibe hoy el pago de tus facturas de forma simple, rápida y sin estrés.\nRegístrate gratis en pocos pasos y comienza a recibir tu dinero.',
  chileImageSrc: 'images/home-hero/home-hero.webp',
  mexicoImageSrc: 'images/home-hero/home-hero-mx.webp',
  entitiesText: 'Con el respaldo de entidades gremiales y alianzas con actores claves del sector financiero',
  entitiesImagesSrc: [
    {
      src: '/logos/skualo.webp',
      alt: 'skualo',
    },
    {
      src: '/logos/senegocia.webp',
      alt: 'senegocia',
    },
    {
      src: '/logos/santander.webp',
      alt: 'santander',
    },
    {
      src: '/logos/manager.webp',
      alt: 'manager',
    },
    {
      src: '/logos/AFYS.webp',
      alt: 'afys',
    },
  ],
};

export default heroData;
